<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.bulletins', 2),
                        href: meta.links.index,
                    },
                    {
                        name: bulletin.title,
                        href: null,
                    },
                ]"
            />
        </template>

        <AppWell>
            <AppCard>
                <div class="font-semibold">
                    {{ bulletin.title }}
                </div>
                <div v-if="bulletin.image_path" class="mt-2">
                    <img :src="bulletin.image_path" alt="cover" />
                </div>
                <p v-html="bulletin.body" class="prose prose-sm" />
                <hr class="my-1" />
                <LinkList :links="bulletin.links" />
            </AppCard>

            <AppCard v-if="bulletin.attachments.length" class="mt-5">
                <AttachmentsList :attachments="bulletin.attachments" />
            </AppCard>
        </AppWell>

        <div class="text-gray-500 text-sm mt-1">{{ bulletin.published_at }} - {{ bulletin.unpublished_at }}</div>

        <div class="text-gray-500 text-xs mt-1">
            {{ bulletin.group_names }}
        </div>

        <div class="md:grid md:grid-cols-2 md:gap-6 mt-5">
            <div>
                <apexchart
                    :type="bulletin.readCountChartData.chart.type"
                    height="350"
                    :series="bulletin.readCountChartData.series"
                    :options="bulletin.readCountChartData"
                >
                </apexchart>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import LinkList from '@/components/LinkList.vue';
import AppWell from '@/Shared/AppWell.vue';
import AppCard from '@/Shared/AppCard.vue';
import AttachmentsList from '@/components/AttachmentsList.vue';

export default {
    components: {
        PanelPage,
        LinkList,
        AppWell,
        AppCard,
        AttachmentsList,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta', 'bulletin', 'options'],
    data() {
        return {
            form: this.$inertia.form({
                title: this.bulletin.title,
                body: this.bulletin.body,
                published_at: this.bulletin.published_at,
                unpublished_at: this.bulletin.unpublished_at,
                group_ids: this.bulletin.group_ids,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
        selectAllGroups() {
            this.form.group_ids = this.options.groups.map((g) => g.value);
        },
    },
};
</script>
